import { ChakraBox, ChakraText } from '@equip.health/ui';

type AdmissionDetailProps = {
  id: string;
  title: string;
  subTitle: string;
};

const AdmissionDetail = ({ id, title, subTitle }: AdmissionDetailProps) => (
  <ChakraBox marginLeft="16px">
    <ChakraText
      color="neutral.primary"
      fontSize="12px"
      fontWeight="500"
      id={`${id}__title`}
      lineHeight="22px"
    >
      {title}
    </ChakraText>
    {subTitle && (
      <ChakraText
        color="neutral.secondary"
        fontSize="12px"
        id={`${id}__sub-title`}
        lineHeight="17px"
        marginTop="2px"
      >
        {subTitle}
      </ChakraText>
    )}
  </ChakraBox>
);

export default AdmissionDetail;
